import { CloseOutlined } from '@ant-design/icons';
import { Display } from '@/components/Display/Display';
import s from './MultimodalReference.module.scss';
import MyIcon from '@/components/MyIcon';
import { Tooltip } from 'antd';
import VideoFileIcon from './icons/VideoFileIcon';

/**
 * 多模态学习引用组件
 * 在 WebSender 底部展示多模态学习内容的摘要
 */
const MultimodalReference = ({ data, from = 'sender', onClose, onListClick, onClick }) => {
    if (!data) return null;

    const { title = '多模态学习', description = '', videoCount = 0, firstVideoTitle = '' } = data;

    // 文本展示：第一个视频标题 + "及其他X个视频"
    const getSummaryText = () => {
        if (!firstVideoTitle && !videoCount) return '';

        const MAX_LEN = 30; // 超出长度时截断加省略号
        let baseTitle = firstVideoTitle || '视频';
        let shortTitle;

        if (baseTitle.length > MAX_LEN) {
            // 保留最后4个字符，前面部分截断加省略号
            const lastFourChars = baseTitle.slice(-4);
            const frontPart = baseTitle.slice(0, MAX_LEN - 4 - 3); // 减去最后4个字符和省略号"..."的3个字符
            shortTitle = `${frontPart}...${lastFourChars}`;
        } else {
            shortTitle = baseTitle;
        }

        const others = Math.max(videoCount - 1, 0);

        if (others > 0) {
            return `${shortTitle}及其他${others}个视频`;
        }
        return shortTitle;
    };

    const summaryText = getSummaryText();

    return (
        <div data-from={from} className={s['multimodal-reference-box']} onClick={onClick} style={onClick ? { cursor: 'pointer' } : undefined}>
            <span className={s['reference-icon']}>
                <i className="iconfont icon-yinyong" style={{ fontSize: '12px', color: '#8C8C8C' }}></i>
            </span>
            <span className={s['icon-wrapper']}>
                <VideoFileIcon width={24} height={24} style={{ verticalAlign: 'middle' }} />
            </span>
            <div className={s['reference-text-wrap']}>
                <span className={s['video-text']}>{summaryText}</span>
            </div>

            <Display show={from === 'sender'}>
                <Tooltip title="查看视频列表">
                    <span onClick={onListClick} className={s['list-icon']}>
                        <MyIcon type="icon-liebiao" />
                    </span>
                </Tooltip>
                <Tooltip title="取消引用">
                    <span onClick={onClose} className={s['close-icon']}>
                        <CloseOutlined />
                    </span>
                </Tooltip>
            </Display>
        </div>
    );
};

export default MultimodalReference;
